import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M18.905 6.672c-.785.773-1.557 1.528-2.323 2.29-.575.573-.399 1.47.351 1.784.135.056.293.078.44.078q3.754.006 7.507.003c.645 0 1.09-.427 1.116-1.076.008-.19.002-.382.002-.573v-6.96c0-.457-.192-.797-.59-1.017-.412-.227-.933-.136-1.27.203Q23.084 2.46 22.026 3.51c-.023.023-.048.042-.05.044-.545-.426-1.06-.868-1.614-1.254-1.446-1.01-3.034-1.72-4.77-2.04-4.821-.885-8.926.482-12.261 4.065C1.513 6.278.44 8.618.114 11.27c-.451 3.652.433 6.95 2.74 9.835 1.558 1.949 3.515 3.35 5.87 4.181 1.11.391 2.257.611 3.43.685 2.568.162 4.98-.384 7.227-1.634a12.7 12.7 0 0 0 3.568-2.958c.233-.278.221-.588-.034-.846l-2.187-2.2c-.337-.34-.672-.32-.967.052-1.214 1.535-2.768 2.556-4.665 3.026-3.72.922-7.55-.678-9.541-3.974-1.02-1.689-1.371-3.521-1.166-5.478.357-3.387 2.933-6.398 6.233-7.314a8.74 8.74 0 0 1 3.848-.208 8.45 8.45 0 0 1 3.775 1.653c.187.144.363.304.543.458.03.025.054.056.117.123"
	})
});
export default SvgRedo;
